'use client';

import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');


//////////////////
// WEBPACK FOOTER
// ../@mui/material/internal/svg-icons/CheckCircle.js
// module id = 1960
// module chunks = 25